import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_4 = { class: "admin" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Remove Asset from Port. Summary", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_7 = { class: "add-Asset-Section" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Add Asset to Port. Summary", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Add Asset")
const _hoisted_10 = { class: "file-upload-section" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "Manual Database Upload", -1)
const _hoisted_12 = { class: "file-upload-section2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "upload-button-container" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Upload Files To Database")
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<br><br><div class=\"instructions\"><h3> 1. Go to <a href=\"https://api.cloud.orionadvisor.com/orionconnectapp/#/reports/dataqueries/querybuilder\"> https://api.cloud.orionadvisor.com/orionconnectapp/#/reports/dataqueries/querybuilder </a></h3><h3> 2. Run &#39;Accounts&#39;. Change the &#39;Run For&#39; dropdown to &#39;Database&#39;, and choose a file type of Excel. Click Run </h3><h3> 3. Run &#39;Products&#39;. Change the &#39;Run For&#39; dropdown to &#39;Database&#39;, change the &#39;As of Date&#39; to today, and choose a file type of Excel. Click Run </h3><h3> 4. Go to <a href=\"https://api.cloud.orionadvisor.com/orionconnectapp/#/reports/dataqueries\"> https://api.cloud.orionadvisor.com/orionconnectapp/#/reports/dataqueries </a></h3><h3>5. Run &#39;28571&#39;. Change &#39;Run To&#39; file type to Excel. Click Run</h3><h3> 6. Add today&#39;s downloaded files to the correct input boxes above, and click Upload. </h3><h3> The Upload process of overwriting the database will begin and should be completed in a few minutes. </h3></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_table_column = _resolveComponent("o-table-column")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_o_table = _resolveComponent("o-table")!
  const _component_o_autocomplete = _resolveComponent("o-autocomplete")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_o_field, { grouped: "" }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Loading..."))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock("div", {
        class: "portSummary",
        id: "adminEditFavAssets",
        key: _ctx.tableKey
      }, [
        _hoisted_5,
        _createVNode(_component_o_table, { data: _ctx.favoriteAssets }, {
          default: _withCtx(() => [
            _createVNode(_component_o_table_column, {
              label: "Ticker",
              field: "ticker",
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.Ticker), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "",
              field: _ctx.tableOverview,
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createVNode(_component_o_button, {
                  class: "deleteButton",
                  onClick: ($event: any) => (_ctx.removeFavoriteAsset(props.row.Ticker))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["field"])
          ]),
          _: 1
        }, 8, ["data"])
      ])),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_o_field, null, {
          default: _withCtx(() => [
            _createVNode(_component_o_autocomplete, {
              modelValue: _ctx.assetToAdd,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.assetToAdd) = $event)),
              placeholder: "ticker",
              "open-on-focus": "",
              data: _ctx.filteredNonfavoriteAssets,
              field: "asset",
              onSelect: _ctx.wait
            }, null, 8, ["modelValue", "data", "onSelect"])
          ]),
          _: 1
        }),
        _createVNode(_component_o_button, { onClick: _ctx.addFavoriteAsset }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_o_button, {
            style: _normalizeStyle({ backgroundColor: _ctx.accountFile ? ' #6ba543' : '' })
          }, {
            default: _withCtx(() => [
              (!_ctx.accountFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "Select Accounts File"))
                : _createCommentVNode("", true),
              (_ctx.accountFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.accountFile?.name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAccountFileSelected && _ctx.onAccountFileSelected(...args))),
                class: "inputButton"
              }, null, 32)
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_o_button, {
            style: _normalizeStyle({ backgroundColor: _ctx.productFile ? ' #6ba543' : '' })
          }, {
            default: _withCtx(() => [
              (!_ctx.productFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Select Products File"))
                : _createCommentVNode("", true),
              (_ctx.productFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.productFile?.name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onProductFileSelected && _ctx.onProductFileSelected(...args))),
                class: "inputButton"
              }, null, 32)
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_o_button, {
            style: _normalizeStyle({ backgroundColor: _ctx.file28571 ? ' #6ba543' : '' })
          }, {
            default: _withCtx(() => [
              (!_ctx.file28571)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Select 28571 File"))
                : _createCommentVNode("", true),
              (_ctx.file28571)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.file28571?.name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("input", {
                type: "file",
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.on28571FileSelected && _ctx.on28571FileSelected(...args))),
                class: "inputButton"
              }, null, 32)
            ]),
            _: 1
          }, 8, ["style"]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (!_ctx.uploaded)
              ? (_openBlock(), _createBlock(_component_o_button, {
                  key: 0,
                  onClick: _ctx.uploadFile
                }, {
                  default: _withCtx(() => [
                    _hoisted_21
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_22
        ])
      ])
    ])
  ]))
}